<template>
  <nav class="navbar">
    <div class="logo">
      <!-- <img
        :src="require('@/page/namvaytien/components/img/logo.png')"
        :alt="logo"
        class="logoImg"
      /> -->
      <span class="title">Confía Negocios Empresariales del Sureste, S.A. de C.V., SOFOM, E.N.R.</span>
    </div>
    <ul class="nav-links">
      <li
        :class="{ 'active-link': isActive('/') }">
        <router-link to="/" class="nav-link1">
          <span class="routeText1">Producto</span>
        </router-link>
      </li>
      <li :class="{ 'active-link': $route.path === '/about' }">
        <router-link to="/about" class="nav-link2">
          <span class="routeText2">Sobre Nosotros</span>
        </router-link>
      </li>
      <li
        :class="{ 'active-link': $route.path === '/information' }">
        <router-link to="/information" class="nav-link3">
          <span class="routeText3">Información</span>
        </router-link>
      </li>
      <li
        :class="{ 'active-link': $route.path === '/support' }">
        <router-link to="/support" class="nav-link4">
          <span class="routeText4">Apoyo</span>
        </router-link>
      </li>
      <li :class="{ 'active-link': $route.path === '/protocol' }">
        <router-link to="/protocol" class="nav-link5">
          <span class="routeText5">Acuerdo de Privacidad</span>
        </router-link>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  data() {
    return {
      logo: "NAM A ASSET MANAGEMENT COMPANY LIMITED",
      backgroundImage: "@/page/namvaytien/components/img/Rectangle.png",
      link1Color: "white", 
    };
  },
  methods: {
   
    isActive(route) {
      return this.$route.path === route;
    },
  },
};
</script>
<style scoped>
.navbar {
  /* height: 120px; */
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* padding: 10px 10px; */
  background-color: white;
  min-width: 1400px;
  /* max-width: 1920px; */
  max-width: 1400px;
  z-index: 100;
}

.logo {
  font-weight: bold;
  color: black;
  display: flex; /* 让 Logo 内容成为一个 flex 容器，使图片和文字水平排列 */
  align-items: center; /* 垂直居中对齐 */
  padding-left: 10px;
}

.logoImg {
  width: 50px;
  height: 50px;
}
.title {
  width: 680px;
  height: 24px;
  font-size: 16px;
  font-family: SF Pro, SF Pro;
  font-weight: 500;
  color: #000000;
  line-height: 23px;
  padding-left: 16px;
}
.routeText1,
.routeText2,
.routeText3,
.routeText4,
.routeText5 {
  font-size: 16px;
  font-family: SF Pro, SF Pro;
  display: flex; /* 设置为弹性盒子 */
  align-items: center; /* 垂直居中 */
  text-align: center;
  line-height: 55px;
}
.routeText1 {
  width: 90px;
  padding-left: 8px;
  padding-right: 8px;
}
.routeText2 {
  width: 140px;
  padding-left: 8px;
  padding-right: 8px;
}
.routeText3 {
  width: 110px;
  padding-left: 8px;
  padding-right: 8px;
}
.routeText4 {
  width: 70px;
  padding-left: 8px;
  padding-right: 8px;
  text-align: center;
}
.routeText5 {
  width: 190px;
  padding-left: 8px;
  padding-right: 8px;
  text-align: center;
}
.nav-links {
  list-style: none;
  display: flex;
}

.nav-links li {
  height: 72px;
}

.nav-link1,
.nav-link2,
.nav-link3,
.nav-link4,
.nav-link5 {
  text-decoration: none;
 /* 将链接文字转为大写 */
  /* text-transform: uppercase; */
  font-size: 16px;
  font-family: SF Pro, SF Pro;
}

.nav-link1 {
  height: 72px;

  font-family: SF Pro, SF Pro;
  font-weight: 500;
  color: #626673;
  line-height: 39px;
}

.nav-link2 {
  height: 72px;

  font-family: SF Pro, SF Pro;
  font-weight: 500;
  color: #626673;
  line-height: 39px;
}
.nav-link3 {
  height: 72px;

  font-family: SF Pro, SF Pro;
  font-weight: 500;
  color: #626673;
  line-height: 39px;
}
.nav-link4 {
  height: 72px;

  font-family: SF Pro, SF Pro;
  font-weight: 500;
  color: #626673;
  line-height: 39px;
}
.nav-link5 {
  height: 72px;

  font-family: SF Pro, SF Pro;
  font-weight: 500;
  color: #626673;
  line-height: 39px;
}
.nav-links li {
  padding: 5px;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  height: 72px;
}
.active-link {
  /* background: url("../page/namvaytien/components/img/Rectangle.png"); */
  background-color: #EBE8FF;
  background-size: 100% 100%; /* 背景图片充满整个容器 */
  background-repeat: no-repeat;
}
.active-link .routeText {
  color: white;
}
.active-link span{
  color: #5243C2;
}
</style>